import type { RagDocument } from "./types";
export function cosineSimilarity(left: number[], right: number[]) {
  if (left.length !== right.length || !left.length) return 0;
  let dot = 0,
    a = 0,
    b = 0;
  for (let i = 0; i < left.length; i++) {
    dot += left[i] * right[i];
    a += left[i] * left[i];
    b += right[i] * right[i];
  }
  return a && b ? dot / (Math.sqrt(a) * Math.sqrt(b)) : 0;
}
export function rankVectorRows(
  rows: Array<{
    id: string;
    content: string;
    vector: number[];
    metadata: Record<string, unknown>;
    scope: "archive" | "global";
  }>,
  query: number[],
  minScore: number,
): RagDocument[] {
  return rows
    .map(
      (row) =>
        ({
          id: row.id,
          content: row.content,
          score: cosineSimilarity(row.vector, query),
          metadata: row.metadata,
          source: row.scope,
        }) as RagDocument,
    )
    .filter((row) => row.score >= minScore)
    .sort((a, b) => b.score - a.score);
}
export function dedupeDocuments(documents: RagDocument[], topK: number) {
  const seen = new Set<string>();
  return documents
    .filter((document) => {
      const key = document.content
        .toLowerCase()
        .replace(/\s+/g, "")
        .slice(0, 260);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((a, b) => b.score - a.score)
    .slice(0, topK);
}
export function renderRagDocuments(documents: RagDocument[]) {
  return documents
    .map(
      (document, index) =>
        `[RAG ${index + 1}｜${document.source}｜${document.score.toFixed(3)}]\n${document.content}`,
    )
    .join("\n\n");
}
